import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';

const GroupOptionsDropdown = props => (
  <Menu
    anchorEl={props.anchorEl}
    open={props.isOpen}
    onClose={props.hideMenu}
    data-testid="group-options-dropdown"
  >
    <MenuItem
      className="ad-option view-content-button"
      onClick={props.handleViewContent}
    >
      View Content
    </MenuItem>
  </Menu>
);

GroupOptionsDropdown.propTypes = {
  anchorEl: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  hideMenu: PropTypes.func.isRequired,
  handleViewContent: PropTypes.func.isRequired,
  handleEditAd: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired
};

GroupOptionsDropdown.defaultProps = {
  anchorEl: {}
};

export default GroupOptionsDropdown;
